import { ref } from 'vue';
import VigiaAPI from 'dashboard/api/vigia';

// Estado compartilhado entre o botão da barra lateral e o painel: agir num
// achado no painel atualiza o contador do botão na hora.
const enabled = ref(false);
const mine = ref(0);
const team = ref(0);
const isAdmin = ref(false);

// Devolve false quando o módulo está desligado (402/403) — quem chama para de perguntar.
export const refreshVigiaSummary = async () => {
  try {
    const { data } = await VigiaAPI.summary();
    enabled.value = !!data.enabled;
    mine.value = data.mine || 0;
    team.value = data.team || 0;
    isAdmin.value = !!data.is_admin;
    return enabled.value;
  } catch (error) {
    const status = error?.response?.status;
    if (status === 402 || status === 403) {
      enabled.value = false;
      return false;
    }
    return enabled.value; // falha de rede: mantém o que já sabia
  }
};

export const useVigiaSummary = () => ({
  enabled,
  mine,
  team,
  isAdmin,
  refresh: refreshVigiaSummary,
});
